<template>
  <div id="user-list">
    <perfil-list-add-new
      v-model="isAddNewPerfilSidebarActive"
      @refetch-data="getPerfis"
    />

    <contadores
      :ativos="ativos"
      :total="total"
      @alterarFiltro="atualizarFiltro"
    />

    <v-card>
      <v-card-text class="d-flex align-center flex-wrap pb-0">
        <v-text-field
          v-model.trim="search"
          placeholder="Pesquisar"
          outlined
          hide-details
          dense
          class="user-search me-3 mb-4"
          @keyup="getPerfis"
        />

        <v-spacer></v-spacer>

        <div class="d-flex align-center flex-wrap">
          <v-btn
            v-if="!acessoPost"
            color="success"
            class="mb-4 px-4"
            disabled
          >
            <v-icon
              left
              size="25"
              class="mr-1"
            >
              {{ icons.mdiPlus }}
            </v-icon>
            <span>Criar Perfis</span>
          </v-btn>

          <v-btn
            v-else
            color="success"
            class="mb-4 px-4"
            @click.stop="isAddNewPerfilSidebarActive = !isAddNewPerfilSidebarActive"
          >
            <v-icon
              left
              size="25"
              class="mr-1"
            >
              {{ icons.mdiPlus }}
            </v-icon>
            <span>Criar Perfis</span>
          </v-btn>
        </div>
      </v-card-text>

      <v-col cols="12">
        <div style="min-height: 4px">
          <v-progress-linear
            v-if="loading"
            indeterminate
          />
        </div>

        <table-perfil
          :items="perfis"
          :acesso-disable="acessoDisable"
          @confirmar-inativacao="getPerfis"
        />
      </v-col>
    </v-card>
  </div>
</template>

<style lang="scss">
@import '@core/preset/preset/apps/user.scss';
</style>

<script>
import { ref, onMounted } from '@vue/composition-api'
import { storeToRefs } from 'pinia'
import { mdiAccount, mdiPlus } from '@mdi/js'
import Contadores from './Contadores.vue'
import TablePerfil from '@/components/tables/TablePerfil.vue'
import PerfilListAddNew from './PerfilListAddNew.vue'
import PerfilService from '@/services/modules/PerfilService'
import useAuthStore from '@/store/auth'

export default {
  components: {
    PerfilListAddNew,
    TablePerfil,
    Contadores,
  },

  setup() {
    const idPost = 1009
    const idDisable = 1011
    const acessoPost = ref(true)
    const acessoDisable = ref(true)

    const { funcionalidades } = storeToRefs(useAuthStore())

    const isAddNewPerfilSidebarActive = ref(false)
    const perfis = ref([])
    const total = ref([])
    const ativos = ref([])
    const loading = ref(true)
    const search = ref('')
    const filtros = ref('')

    const getPerfis = async () => {
      try {
        const data = await PerfilService.get()

        perfis.value = data

        total.value = perfis.value
        ativos.value = perfis.value.filter(p => p.ativo === true)

        if (search.value) {
          perfis.value = perfis.value.filter(p => p.nome.toLowerCase().includes(search.value.toLowerCase())
            || p.descricao.toLowerCase().includes(search.value.toLowerCase()))
        }
        if (filtros.value) {
          perfis.value = perfis.value.filter(
            p => p.ativo === filtros.value || p.ativo.toString() === filtros.value,
          )
        }

        perfis.value.sort((a, b) => new Date(b.dataCadastro) - new Date(a.dataCadastro))

        setTimeout(() => {
          loading.value = false
        }, 1000)
      } catch {
        loading.value = false
      }
    }

    function permissoes() {
      if (!funcionalidades.value.includes(idPost)) {
        acessoPost.value = false
      }
      if (!funcionalidades.value.includes(idDisable)) {
        acessoDisable.value = false
      }
    }

    function atualizarFiltro(item) {
      filtros.value = item
      getPerfis()
    }

    onMounted(() => {
      getPerfis()
      // permissoes()
    })

    return {
      isAddNewPerfilSidebarActive,
      acessoPost,
      acessoDisable,
      perfis,
      ativos,
      total,
      loading,
      search,
      filtros,
      getPerfis,
      atualizarFiltro,
      icons: {
        mdiPlus,
        mdiAccount,
      },
    }
  },
}
</script>
